import {
  List,
  ListItem,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  Text,
  Link,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

export function WhatToDeclareModal() {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={({ open }) => (
        <>
          <Link
            textStyle="global/body-secondary"
            textColor="text-weak"
            onPress={open}
            testID="criminal-convictions-what-not-to-declare-button"
          >
            <Trans>What not to declare</Trans>
          </Link>
          .
        </>
      )}
    >
      {(close) => (
        <LegacyModal>
          <ModalHeader close={close} title={t("What not to declare")} />
          <ModalContent>
            <List type="unordered" size="secondary">
              <ListItem>
                <Trans>
                  A conviction for which you have received a Record Suspension
                  (formerly pardon) in accordance with the Criminal Records Act
                </Trans>
              </ListItem>
              <ListItem>
                <Trans>
                  A conviction where you were a "young person" under the Youth
                  Criminal Justice Act
                </Trans>
              </ListItem>
              <ListItem>
                <Trans>
                  An Absolute or Conditional Discharge, pursuant to section 730
                  of the Criminal Code
                </Trans>
              </ListItem>
              <ListItem>
                <Trans>An offense for which you were not convicted</Trans>
              </ListItem>
              <ListItem>
                <Trans>Any provincial or municipal offense</Trans>
              </ListItem>
              <ListItem>
                <Trans>Any charges dealt with outside of Canada</Trans>
              </ListItem>
            </List>
            <br />
            <Text style="global/body-secondary">
              <Trans>
                Note: A Certified Criminal Record can only be issued based on
                the submission of fingerprints to the RCMP National Repository
                of Criminal Records.
              </Trans>
            </Text>
          </ModalContent>
          <ModalFooter>
            <PrimaryButton size="medium" onPress={close}>
              <Trans>Okay</Trans>
            </PrimaryButton>
          </ModalFooter>
        </LegacyModal>
      )}
    </ModalTrigger>
  );
}
